import React from "react";
import { Navigate } from "react-router-dom";

// The shop IS the homepage grid (yeezy.com style).
const Shop = () => <Navigate to="/" replace />;

export default Shop;
